declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SavePatientInfoRequest, PatientInfoByFormattedCodeController, UpdatePatientInfoRequest, SaveActorRegistationType, GenericProcPostRequest, S_Methods, SaveJoinSpouse, UpdateRegistration, UpdateOverseas, GenericParams, FTV, OverseasController, UpdateBillingCategory, UpdateWeddingDate, AddPartner } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from '../../../../ivf/ivfworkbench/searchprovider.modal';
import { NgbSearchPatientModal } from '../../../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbCameraUploadModal } from './cameraupload.modal';

import { NgbPartnerSearchpatientModal } from '../../../../follow up/counsellingregistry/modal/partnersearchpatient.modal';

@Component({
  selector: 'ngbaddpartner',
  templateUrl: './addpartner.modal.html',
  styleUrls: ['./addpartner.modal.scss']
})

export class NgbAddPartnerModal implements OnInit, OnChanges {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  public isvisible: boolean = true;
  // @Input() CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  @Input() CurrentSavePatientInfoRequest: UpdatePatientInfoRequest;
  @Input() CurrentUpdateOverseas: UpdateOverseas;
  @Input() CurrentUpdateBillingCategory: UpdateBillingCategory;
  @Input() CurrentUpdateWeddingDate: UpdateWeddingDate;
  @Input() ServiceCode: number;
  @Input() FormattedCode: string;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  DOB: NgbDateStruct;
  WeddingDate: NgbDateStruct;
  RegistrationVal: NgbDateStruct;
  VaildFrom: NgbDateStruct;
    ValidTo: NgbDateStruct;
    
  public SelectedSource: string;
  public ProviderName: string;
  public ProviderCode: number;
  public ProviderNumber: string;
  public PrimaryDoctor: string;
  public PrimaryCode: number;
  public PrimaryNumber: number;
  public ProviderName1: string;
  public ProviderCode1: number;
  public ProviderNumber1: string;
  public PatientName: string;
  public PatientActorCode: number;
  public PatientNumber: string;
    public StaffName: string;
    public Institute: string;
  public StaffCode: number;
  public StaffNumber: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public PrimaryDoctorO: boolean = true;
  public PrimaryDoctorn: boolean = false;
  public LoginCountry: string;

  public PartnerName: string;
  public PartnerFormattedCode: string;
  public PartnerActorCode: number;
  public SpouseNameO: boolean = true;
  public SpouseNameN: boolean = false;

  public NewFormattedCode: string;
    Todate = new Date();
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnChanges(changes: SimpleChanges) {
    //alert('yeah - 0');
    //for (const propName in changes) {
    //  if (changes.hasOwnProperty(propName)) {
    //    alert(propName);
    //    switch (propName) {
    //      case 'CurrentSavePatientInfoRequest.County': {
    //        alert('yeah');
    //       // this.doSomething(change.currentValue)
    //      }
    //    }
    //  }
    //}
    
  }
  ngOnInit() {

    this.ShowService = false;
    //alert(this.CurrentSavePatientInfoRequest.PrimaryDoctor);
      this.minDate = { year: 1900, month: 1, day: 1 };
      this.maxDate = { year: this.Todate.getFullYear(), month: 1, day: 1 };
    this.LoadRegistries();
 

    this.CurrentUpdateRegistration = new UpdateRegistration();
    this.CurrentUpdateRegistration.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.CurrentUpdateWeddingDate = new UpdateWeddingDate();
    //this.CurrentUpdateWeddingDate.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.CurrentUpdateBillingCategory = new UpdateBillingCategory();
    //this.CurrentUpdateBillingCategory.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    //this.CurrentUpdateOverseas = new UpdateOverseas();
    //this.CurrentUpdateOverseas.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //alert(this.CurrentSavePatientInfoRequest.DateOfBirth);

    if (this.CurrentSavePatientInfoRequest.DateOfBirth != null) {
      var SValidFrom = new Date(this.CurrentSavePatientInfoRequest.DateOfBirth);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.DOB = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentUpdateWeddingDate.WeddingDate != null) {
      var SValidFrom = new Date(this.CurrentUpdateWeddingDate.WeddingDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.WeddingDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentSavePatientInfoRequest.RegistrationValidity != null) {
      var SValidFrom = new Date(this.CurrentSavePatientInfoRequest.RegistrationValidity);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.RegistrationVal = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    
    //this.LoadOverseas();
    if (this.CurrentUpdateOverseas.PassportExpiryDate != null) {
      var SValidFrom = new Date(this.CurrentUpdateOverseas.PassportExpiryDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.PassportExpiryDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentAddPartner.PartnerDateOfBirth != null) {
      var SValidFrom = new Date(this.CurrentAddPartner.PartnerDateOfBirth);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.PartnerDateOfBirth = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentUpdateOverseas.VisaExpiryDate != null) {
      var SValidFrom = new Date(this.CurrentUpdateOverseas.VisaExpiryDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.UpdateDate >1990');
        this.VisaExpiryDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }

    this.LoginCountry = AppData.Instance().cas.LoginCountry;

  }

  IsLocalCountry() :boolean {
    var cns = this.LoginCountry.trim().split("|");
    //alert(cns.length);
    //alert(cns.indexOf(this.CurrentSavePatientInfoRequest.County));
    for(var c in cns)
    {
      if (c.trim() == this.CurrentSavePatientInfoRequest.County.trim())
        return true;

      if (c.indexOf(this.CurrentSavePatientInfoRequest.County.trim()) > -1)
        return true;
    }
    return false;
  }



  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
  //this.pdata = this.CurrentCustomCodeValuesController;
  LoadRegistries() {
    this.StartRefreshing();




    //this.GetBranchMap();



  }
  //General() {

  //}
  public PartnerSalutation: string;
  public PartnerDisplayName: string;
  public PartnerDateOfBirth: NgbDateStruct;
  public PartnerGender: string;
  public PartnerMobileNumber: string;
  CurrentAddPartner: AddPartner;
  AddPartner() {
    var saveReq = new AddPartner();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40400;
    saveReq.ActionTag = 'AddPartner';
    saveReq.ExistingPatientName = this.CurrentSavePatientInfoRequest.DisplayName;
    saveReq.ExistingFormattedCode = this.FormattedCode;
    saveReq.PartnerSalutation = this.PartnerSalutation;
    saveReq.PartnerDisplayName = this.PartnerDisplayName;
    saveReq.PartnerDateOfBirth = new Date(this.parserFormatter.format(this.PartnerDateOfBirth));
    saveReq.PartnerGender = this.PartnerGender;
    saveReq.PartnerMobileNumber = this.PartnerMobileNumber;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40400;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.isvisible = false;
          this.stopRefreshing();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  LinkPartner() {
    var saveReq = new AddPartner();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40400;
    saveReq.ActionTag = 'LinkPartner';
    saveReq.ExistingPatientName = this.CurrentSavePatientInfoRequest.DisplayName;
    saveReq.ExistingFormattedCode = this.FormattedCode;
    saveReq.PartnerFormattedCode = this.PartnerFormattedCode;
    saveReq.PartnerDisplayName = this.PartnerName;
    saveReq.PartnerActorCode = this.PartnerActorCode;    
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40400;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.isvisible = false;
          this.stopRefreshing();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  CurrentUpdateRegistration: UpdateRegistration;
  UpdateRegistration() {
    var saveReq = new UpdateRegistration();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40240;
    saveReq.OldFormattedCode = this.FormattedCode;
    saveReq.NewFormattedCode = this.NewFormattedCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40240;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }



  public PassportNumber: string;
  public PassportExpiryDate: NgbDateStruct;
  public VisaType: string;
  public IssueCountry: string;
  public NationalRegNo: string;
  public VisaExpiryDate: NgbDateStruct;
  public BillingCategory: string;
  //CurrentUpdateOverseas: UpdateOverseas;
  UpdateOverseas() {
    var saveReq = new UpdateOverseas();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40250;
    saveReq.PassportNumber = this.CurrentUpdateOverseas.PassportNumber;
    saveReq.PassportExpiryDate = new Date(this.parserFormatter.format(this.PassportExpiryDate));
    saveReq.VisaType = this.CurrentUpdateOverseas.VisaType;
    saveReq.IssueCountry = this.CurrentUpdateOverseas.IssueCountry;
    saveReq.VisaExpiryDate = new Date(this.parserFormatter.format(this.VisaExpiryDate));
    saveReq.NationalRegNo = this.CurrentUpdateOverseas.NationalRegNo;
    saveReq.FormattedCode = this.FormattedCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40250;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  //CurrentUpdateBillingCategory: UpdateBillingCategory;
  UpdateBillingCategory() {
    var saveReq = new UpdateBillingCategory();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40280;
    saveReq.BillingCategory = this.CurrentUpdateBillingCategory.BillingCategory;
    saveReq.FormattedCode = this.FormattedCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40280;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  UpdateWeddingDate() {
    var saveReq = new UpdateWeddingDate();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40310;
    saveReq.WeddingDate = new Date(this.parserFormatter.format(this.WeddingDate));
    saveReq.FormattedCode = this.FormattedCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40310;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  General() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 7;
    this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));

    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Education() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 14;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  CurrentJoinSpouse = new SaveJoinSpouse();
  JoinSpouse() {
    var saveReq = new SaveJoinSpouse();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40092;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SelectedActorcode = this.CurrentSavePatientInfoRequest.ActorCode;
    saveReq.PartnerActorCode = this.PartnerActorCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40092;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  CurrentSaveActorRegistationType = new SaveActorRegistationType();
  ChangeRegistrationType() {
    var saveReq = new SaveActorRegistationType();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40082;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.DonorType = this.CurrentSaveActorRegistationType.DonorType;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40082;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  Registration() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 21;
    //this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingDate));
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Referral() {
    this.StartRefreshing();
    if (this.SelectedSource == "DOC") {
      this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber;
    }
    else if (this.SelectedSource == "DOCEX") {
      //  this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode1;
      //this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
      //  this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;
        if (this.CurrentSavePatientInfoRequest.RefCode == null) {
            this.CurrentSavePatientInfoRequest.RefCode = -1;
        }

    }
    else if (this.SelectedSource == "RGPT") {
      this.CurrentSavePatientInfoRequest.RefCode = this.PatientActorCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.PatientName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.PatientNumber;
    }
    else if (this.SelectedSource == "STAFF") {
      this.CurrentSavePatientInfoRequest.RefCode = this.StaffCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.StaffName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.StaffNumber;
    }
    else if (this.SelectedSource !== "DOC" || "DOCEX" || "RGPT" || "STAFF") {
      this.CurrentSavePatientInfoRequest.RefCode = 0;

    }

    this.CurrentSavePatientInfoRequest.ConditionalOperator = 35;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Adress() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 42;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Contact() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 49;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            //this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }

  //onSubmit() {

  //  this.StartRefreshing();
  //  if (this.SelectedSource == "DOC") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.ProviderCode;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber;
  //  }
  //  else if (this.SelectedSource == "DOCEX") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.ProviderCode1;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;

  //  }
  //  else if (this.SelectedSource == "RGPT") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.PatientActorCode;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.PatientName;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.PatientNumber;
  //  }
  //  else if (this.SelectedSource == "STAFF") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.StaffCode;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.StaffName;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.StaffNumber;
  //  }
  //  else if (this.SelectedSource !== "DOC" || "DOCEX" || "RGPT" || "STAFF") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = 0;

  //  }    
  //  this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));
  //  this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingDate));
  //  this.CurrentSavePatientInfoRequest.RegistrationValidity = new Date(this.parserFormatter.format(this.RegistrationVal));
  //  this.CurrentSavePatientInfoRequest.ValidFrom = new Date(this.parserFormatter.format(this.VaildFrom));
  //  this.CurrentSavePatientInfoRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));
  //  this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result > 0) {
  //          this.ShowService = false;            
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

  //          this.activeModal.close();

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");
  //          this.activeModal.close();

  //          this.stopRefreshing();

  //        }

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //          this.activeModal.close();


  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //          this.activeModal.close();
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();
  //        }
  //      }
  //    );

  //}




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  onChange2(event: any) {
    this.SelectedSource = event;
    // alert(this.SelectedSource)

  }
  SelectInternalDoctor() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName = receivedEntry.make;
      this.ProviderCode = receivedEntry.value;
      this.ProviderNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }
  SelectExternalDoctor() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = false;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName1 = receivedEntry.make;
      this.ProviderCode1 = receivedEntry.value;
        this.ProviderNumber1 = receivedEntry.number;      //alert(this.ProviderName);
        this.Institute = receivedEntry.Institute;
          this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode1;
      this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
        this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;
        this.CurrentSavePatientInfoRequest.RefInstitute = this.Institute;
    })
  }
  SelectStaff() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.StaffName = receivedEntry.make;
      this.StaffCode = receivedEntry.value;
      this.StaffNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }
  SelectPatient() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg'
      })
    modalRef.componentInstance.PATIENT_OBJ = true;
    modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
    modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
      // alert(val.DisplayName);

      this.PatientActorCode = val.ActorCode;

      this.PatientName = val.DisplayName;
      this.PatientNumber = val.Telephone1;
      //  this.SaveAppt_SelectedPatient();
      //modalRef.result.
      ////alert(val);
      //const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
      //    {
      //        centered: true,
      //        size: 'lg'
      //    })
      //modalRef.componentInstance.FormattedCode = val;
      //modalRef.result.then(x => { this.GetCounsellingPlanController() })
    });
  }
  //OpenCamera() {
  //    const modalRef = this.modalService.open(NgbCameraUploadModal,
  //     {
  //          centered: true

  //      })
  //}
  SelectPrimaryDoctor() {
    this.PrimaryDoctorO = false;
    this.PrimaryDoctorn = true;
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.PrimaryDoctor = receivedEntry.make;
      this.PrimaryCode = receivedEntry.value;
      this.PrimaryNumber = receivedEntry.number;
      this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
      //alert(this.ProviderName);
    })
  }

  SelectSpouse() {
    //this.SpouseNameO = false;
    //this.SpouseNameN = true;
    const modalRef = this.modalService.open(NgbPartnerSearchpatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    //modalRef.componentInstance.IsShowDoctor = true;
    //modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.PartnerName = receivedEntry.make;
      this.PartnerFormattedCode = receivedEntry.value;
      this.PartnerActorCode = receivedEntry.number;
      //this.CurrentJoinSpouse.SpouseName = this.SpouseName;

    //modalRef.result.then((val: string) => {
    //    this.SpouseFormattedCode = val;
    //    alert(this.SpouseFormattedCode);
    })
  }
  //public IsCountry: boolean = true;
  //CountryChange(e: any) {
  //  if (this.CurrentSavePatientInfoRequest.County == 'INDIA')
  //    this.IsCountry = true;
  //  else
  //    this.IsCountry = false;
  //}
  public DepartmentCode: number;
  CountryName: string;
  Country(event: any) {

    if (event != null) {
      this.CountryName = event;
      //alert(this.CountryName);
    }

  }
}
